import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

export const CREDENTIAL_SETUP_FEATURE_FLAG = 'hermes.credentialSetup'

export const checkCredentialSetupFeatureFlag: HermesGuardFn = async (to) => {
  if (to.name !== 'auth.credential-setup') return undefined

  const featureFlags = useFeatureFlags()

  if (!featureFlags.isEnabled(CREDENTIAL_SETUP_FEATURE_FLAG)) {
    return { path: '/' }
  }

  return undefined
}
